import { clsx } from 'clsx'
import { LinkProps } from 'next/link'
import { Button, ButtonLink } from '~/sotano-kit/primitives/button'

type BranchBadgeProps<IsAnchor extends LinkProps['href']> = {
  variant?: 'highlight' | 'muted'
  className?: string
  children: React.ReactNode
  href?: IsAnchor
  onClick?: IsAnchor extends undefined
    ? React.MouseEventHandler<HTMLButtonElement> | undefined
    : React.MouseEventHandler<HTMLAnchorElement> | undefined
}

export const BranchBadge = <IsAnchor extends LinkProps['href']>({
  variant,
  children,
  className,
  href,
  onClick,
}: BranchBadgeProps<IsAnchor>) => {
  const classNames = clsx(
    className,
    'leading-normal px-1 rounded font-medium inline-flex items-center',
    variant === 'highlight'
      ? 'text-dark-control-base bg-dark-accent/15'
      : 'text-dark-muted bg-dark-shade-hover light:bg-dark-shade'
  )

  if (href) {
    return (
      <ButtonLink
        unstyled
        focusStyled
        href={href}
        onClick={onClick}
        className={clsx(
          classNames,
          'cursor-default',
          variant === 'highlight'
            ? 'hover:bg-dark-accent/30'
            : 'hover:bg-dark-elevated'
        )}
      >
        {children}
      </ButtonLink>
    )
  }

  if (onClick) {
    return (
      <Button
        unstyled
        focusStyled
        onClick={
          onClick as unknown as React.MouseEventHandler<HTMLButtonElement>
        }
        className={clsx(
          classNames,
          'cursor-default',
          variant === 'highlight'
            ? 'hover:bg-dark-accent/30'
            : 'hover:bg-dark-elevated'
        )}
      >
        {children}
      </Button>
    )
  }

  return <span className={classNames}>{children}</span>
}
